const regions = [
    {
        id: 16,
        code: '84',
        name: 'Auvergne-Rh\u00f4ne-Alpes',
        slug: 'auvergne rhone alpes',
    },
    {
        id: 8,
        code: '27',
        name: 'Bourgogne-Franche-Comt\u00e9',
        slug: 'bourgogne franche comte',
    },
    { id: 13, code: '53', name: 'Bretagne', slug: 'bretagne' },
    {
        id: 7,
        code: '24',
        name: 'Centre-Val de Loire',
        slug: 'centre val de loire',
    },
    {
        id: 19,
        code: 'COM',
        name: "Collectivit\u00e9s d'Outre-Mer",
        slug: 'collectivites doutre mer',
    },
    { id: 18, code: '94', name: 'Corse', slug: 'corse' },
    { id: 11, code: '44', name: 'Grand Est', slug: 'grand est' },
    { id: 1, code: '01', name: 'Guadeloupe', slug: 'guadeloupe' },
    { id: 3, code: '03', name: 'Guyane', slug: 'guyane' },
    {
        id: 10,
        code: '32',
        name: 'Hauts-de-France',
        slug: 'hauts de france',
    },
    {
        id: 6,
        code: '11',
        name: '\u00cele-de-France',
        slug: 'ile de france',
    },
    { id: 4, code: '04', name: 'La R\u00e9union', slug: 'la reunion' },
    { id: 2, code: '02', name: 'Martinique', slug: 'martinique' },
    { id: 5, code: '06', name: 'Mayotte', slug: 'mayotte' },
    { id: 9, code: '28', name: 'Normandie', slug: 'normandie' },
    {
        id: 14,
        code: '75',
        name: 'Nouvelle-Aquitaine',
        slug: 'nouvelle aquitaine',
    },
    {
        id: 12,
        code: '52',
        name: 'Pays de la Loire',
        slug: 'pays de la loire',
    },
    { id: 15, code: '76', name: 'Occitanie', slug: 'occitanie' },
    {
        id: 17,
        code: '93',
        name: "Provence-Alpes-C\u00f4te d'Azur",
        slug: 'provence alpes cote dazur',
    },
];

export default regions;
